import { plugin, Mode } from 'light-component';
import { useTranslation } from '@common';
import { WidgetType } from '../types';
import { Thumbnail } from '../../component';
import { NumberInputMode } from './input';
import { NumberDesignMode } from './design';
import { NumberViewMode } from './view';
import type { ReactElement } from 'react';
import type { NumberProps } from './types';

export function Number(props: NumberProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='NumberIcon' title={t('Number')} toolTipContent={t('仅可输入数字')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<NumberDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<NumberViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<NumberInputMode {...props} />);
  }

  return null;
}

Number.prototype.type = WidgetType.NUMBER;
plugin.register({ kind: 'widget', component: Number });
